<template>
    <div class="contact" v-if="contactImg">
        <img :src="contactImg"/>
      </div>
</template>


<script>
import {picDetail} from '@/api/server/pic'

export default {
  name: 'ContactComponent',
  data () {
    return {
        contactImg: null
    }
  },
  computed: {
  },
  methods: {
    _getPic (cid) {
      let query = {
        cid: cid
      }
      picDetail(query).then( (res) => {
        if (res.code === 200) {
          this.contactImg = res.data.img
        }
      })
    },
  },
  mounted: function () {
    this._getPic(2)
  }

}
</script>
<style lang="scss" scoped>
</style>